import { useEffect, useLayoutEffect, type RefObject } from "react";

export function useScrollRestoration(
  ref: RefObject<HTMLElement | null>,
  key: string,
  enabled: boolean,
): void {
  const storageKey = `scroll-restore:${key}`;

  useLayoutEffect(() => {
    if (!enabled) return;
    const element = ref.current;
    if (element === null) return;
    const stored = sessionStorage.getItem(storageKey);
    if (stored === null) return;
    const value = Number(stored);
    if (!Number.isFinite(value) || value <= 0) return;
    element.scrollTop = value;
  }, [ref, storageKey, enabled]);

  useEffect(() => {
    if (!enabled) return;
    const element = ref.current;
    if (element === null) return;

    const handleScroll = (): void => {
      sessionStorage.setItem(storageKey, String(element.scrollTop));
    };

    element.addEventListener("scroll", handleScroll, { passive: true });
    return (): void => {
      element.removeEventListener("scroll", handleScroll);
    };
  }, [ref, storageKey, enabled]);
}
